export const getRouteLink = (path, environment) => {
    if (!environment) {
        return '';
    }
    return `/site/study/${environment.id}/${path}`;
};
export const appendSiteIdToPath = (path, siteId) => {
    const url = new URL(path);
    url.searchParams.set('siteId', siteId);
    return url.toString();
};
